export enum Routes {
  HOME = '/',
  ONBOARDING = '/onboarding',
  PAGES_MANAGEMENT = '/pages',
  MEETING_PAGE = '/page/:company/:pageName',
  INTEGRATIONS = '/integrations/:integration',
  PRIVACY = '/privacy',
  COOKIES = '/cookie',
  LOGIN = '/login',
  LOGOUT = '/logout',
  SETTINGS = '/settings',
  COMPANY_APPROVE = 'company/approve',
  MY_MEETINGS = '/my-meetings',
  MY_MEETINGS_DETAIL = '/my-meetings/:meetingId',
}
